import React from 'react';
import { Link } from 'react-router-dom';
import './TestsLanding.css';

const TestsLanding = () => {
    return (
        <>
            <div className='grid-card'>
                <div className='card'>
                    <img className='test-image' src='https://konfidenceonline.com/assets/img/praktiz-aptitude.png' alt='aptitude test' />
                    <h1 className='test-title'>Cognitive Ability</h1>
                    {/* <p className='test-info'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus fermentum placerat fringilla. Sed placerat mi ut leo accumsan pretium. Praesent at est enim. </p> */}
                    {/* <Link to='/aptitude-test'>
                        <button className='header-page-button'> Give test </button>
                    </Link>     */}
                    <a href='#' target='_blank'>
                        <button className='header-page-button'> Give test </button>
                    </a>
                </div>

                <div className='card'>
                    <img className='test-image' src='https://image.freepik.com/free-vector/statistical-analysis-man-cartoon-character-with-magnifying-glass-analyzing-data-circular-diagram-with-colorful-segments-statistics-audit-research_335657-2698.jpg' alt='personality test' />
                    <h1 className='test-title'>Effectiveness Scale</h1>
                    {/* <p className='test-info'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus fermentum placerat fringilla. Sed placerat mi ut leo accumsan pretium. Praesent at est enim. </p> */}
                    <Link to='/personality-test'>
                        <button className='header-page-button'> Give test </button>
                    </Link>
                </div>

                <div className='card'>
                    <img className='test-image' src='https://img.freepik.com/free-vector/person-covering-emotions-searching-identity_74855-5560.jpg' alt='eq test' />
                    <h1 className='test-title'>EQ Test</h1>
                    {/* <p className='test-info'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus fermentum placerat fringilla. Sed placerat mi ut leo accumsan pretium. Praesent at est enim. </p> */}
                    <Link to='/eq-test'>
                        <button className='header-page-button'> Give test </button>
                    </Link>
                </div>
            </div>
        </>
    );
}

export default TestsLanding;

//https://img.freepik.com/free-vector/sign-up-concept-illustration_114360-7965.jpg?w=740